import {
  HandsControlData,
  MediapipeHandResults,
} from "/@/shared/motion-menu-system/MenuTypes";

import {
  chooseNonClenchedFavouredHand,
  getCorrectedHandLandmarks,
} from "./common.ts";
import { detectClench } from "./hands-clench.ts";
import {
  generateIndexFingerAngleAndAngularVelocityConverter,
} from "./hands-index-finger-angle.ts";
import {
  generatehandAnglesAndAngularVelocityConverter,
} from "./hands-palm-angles.ts";
import {
  generateHandsToAngleConverter,
} from "./hands-palm-orthgonal-direction.ts";
import { calculateWristRotation } from "./hands-rotation.ts";
import { calculateHandsSplay } from "./hands-splay.ts";

export const generateHandsControl = (): (
  hands: MediapipeHandResults,
) => HandsControlData => {
  const calculateHandWaveVelocity =
    generatehandAnglesAndAngularVelocityConverter();
  const calculateHandPalmDirection = generateHandsToAngleConverter();
  const calculateIndexFingerAngleAndAngularVelocity =
    generateIndexFingerAngleAndAngularVelocityConverter();

  return (hands: MediapipeHandResults): HandsControlData => {
    const clench = detectClench(hands);

    const [keypoints3DLeft, keypoints3DRight] = getCorrectedHandLandmarks(
      hands,
    );
    const wristRotationLeft = calculateWristRotation(keypoints3DLeft);
    const wristRotationRight = calculateWristRotation(keypoints3DRight);

    const handAnglesAndAngularVelocity = calculateHandWaveVelocity(hands);
    const handPalmOrthogonal = calculateHandPalmDirection(hands);
    const handSplay = calculateHandsSplay(hands);

    const indexFingerAngleAndAngularVelocity =
      calculateIndexFingerAngleAndAngularVelocity(hands);

    // add some clench filtering (do not use the hand that is clenched)
    const favouredHandBasedOnClench = chooseNonClenchedFavouredHand(clench);

    const palmOrthogonalEulerNotClenched = favouredHandBasedOnClench === -1
      ? handPalmOrthogonal?.palmOrthogonalEulerLeft
      : favouredHandBasedOnClench === 1
      ? handPalmOrthogonal?.palmOrthogonalEulerRight
      : undefined;
    const palmOrthogonalQuaternionNotClenched = favouredHandBasedOnClench === -1
      ? handPalmOrthogonal?.palmOrthogonalQuaternionLeft
      : favouredHandBasedOnClench === 1
      ? handPalmOrthogonal?.palmOrthogonalQuaternionRight
      : undefined;
    const wristRotationNotClenched = favouredHandBasedOnClench === -1
      ? wristRotationLeft
      : favouredHandBasedOnClench === 1
      ? wristRotationRight
      : undefined;
    const handSplayNotClenched = favouredHandBasedOnClench === -1
      ? handSplay.handSplayLeft
      : favouredHandBasedOnClench === 1
      ? handSplay.handSplayRight
      : undefined;

    const isPalmFlatLeft = handSplay?.isHandSplayLeftFlat &&
      !!clench?.meanClenchAngleLeft &&
      clench?.meanClenchAngleLeft >= 2.8;
    const isPalmFlatRight = handSplay?.isHandSplayRightFlat &&
      !!clench?.meanClenchAngleRight && clench?.meanClenchAngleRight >= 2.8;

    return {
      clench,
      wristRotationLeft,
      wristRotationRight,
      palmOrthogonalEulerNotClenched,
      palmOrthogonalQuaternionNotClenched,
      wristRotationNotClenched,
      ...handAnglesAndAngularVelocity,
      ...handPalmOrthogonal,
      ...handSplay,
      ...indexFingerAngleAndAngularVelocity,
      handSplayNotClenched,
      isPalmFlatLeft,
      isPalmFlatRight,
    };
  };
};
